import FullScreenOverlayConstants from '../constants/FullScreenOverlayConstants';

export function openOverlay(overlayKey, { authRequired = false, accountRequired = false, ...overlayData } = {}) {
  return {
    overlayKey,
    overlayData,
    type: FullScreenOverlayConstants.OPEN_FULLSCREEN_OVERLAY,
    middlewareData: {
      authRequired,
      accountRequired
    }
  };
}

export function closeOverlay(overlayKey) {
  return {
    overlayKey,
    type: FullScreenOverlayConstants.CLOSE_FULLSCREEN_OVERLAY
  };
}

export default {
  openOverlay,
  closeOverlay
};
